import isEqual from 'lodash/isEqual';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export default class BaseModel
{

    isModel()
    {
        return true;
    }

    constructor(data, params = {})
    {
        // console.log('BaseModel constructor', this.constructor.name, data, params);
        // console.trace(this);
        this.init(data);
        
        this.internal_uuid = uuidv4();
        this.originalParams = params;

        if ( typeof this.originalParams.registerEvents === 'undefined' || this.originalParams.registerEvents === true ) {
            this.modelUpdatedEventCallback = item => { this.refresh(item); };
            this.modelDeletedEventCallback = uuid => { this.onModelDestroyed(uuid); };
            window.App.$bus.$on(`${this.constructor.getPrefix()}:updated`, this.modelUpdatedEventCallback);
            window.App.$bus.$on(`${this.constructor.getPrefix()}:deleted`, this.modelDeletedEventCallback);
        }
    }

    init(data)
    {    
        this.originalData = cloneDeep(data);

        if ( data.user_id ) {
            this.user_id = data.user_id;
            this.user = this.getUser(true);
        }

        this.trustup_io = data.trustup_io;

        for ( let key in data ) {
            this[key] = data[key];
        }
    }

    initOnRefresh(data)
    {
        this.init(data);
    }

    destroy()
    {
        window.App.$bus.$off(`${this.constructor.getPrefix()}:updated`, this.modelUpdatedEventCallback);
        window.App.$bus.$off(`${this.constructor.getPrefix()}:deleted`, this.modelDeletedEventCallback);
    }

    onModelDestroyed(uuid)
    {
        if ( this.uuid !== uuid ) {
            return;
        }

        this.destroy();
    }

    static getEndpoint()
    {
        return null;
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint();
    }

    static getPrefix()
    {
        return 'app-key:model-key';
    }
    static getComponentPrefix()
    {
        return this.getPrefix();
    }

    static getModalName()
    {
        return `${this.getComponentPrefix()}-modal`;
    }
    static getModalEvent()
    {
        return `${this.getModalName()}:open`;
    }

    static getFormModalName()
    {
        return `${this.getComponentPrefix()}-form-modal`;
    }
    static getFormModalEvent()
    {
        return `${this.getFormModalName()}:open`;
    }

    static getContextMenuName()
    {
        return `${this.getComponentPrefix()}-context-menu`;
    }
    static getContextMenuEvent()
    {
        return `${this.getContextMenuName()}:open`;
    }

    getRoute()
    {
        return {};
    }

    open()
    {
        window.App.$router.push(this.getRoute());
    }

    preview(data = {})
    {
        window.App.$bus.$emit(this.constructor.getModalEvent(), {...{model: this}, ...data});
    }

    edit(data = {})
    {
        window.App.$bus.$emit(this.constructor.getFormModalEvent(), {...{model: this}, ...data});
    }

    contextMenu($event, data = {})
    {
        window.App.$bus.$emit(this.constructor.getContextMenuEvent(), {...{model: this, event: $event}, ...data});
    }

    getDownloadUrl()
    {
        return null;
    }

    isDownloadable()
    {
        return this.getDownloadUrl() !== null;
    }

    download()
    {
        window.open(this.getDownloadUrl(), "_blank");
    }

    refresh(newModel)
    {
        console.log('Check for refresh', {
            new_model: newModel,
            new_model_uuid: newModel.internal_uuid,
            current_model: this,
            current_model_uuid: this.internal_uuid,
            refresh: newModel.uuid == this.uuid,
            current_model_collection: this.currentCollection?.internal_uuid
        });
        if ( newModel.uuid !== this.uuid ) {
            return;
        }

        // TODO: Check if current version is newer than the one we are refreshing

        newModel.destroy();
        this.initOnRefresh(newModel.originalData);
    }

    data()
    {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    getUser(fresh = false)
    {
        if ( ! fresh ) {
            return this.user;
        }

        this.user = null;

        if ( this.user_id ) {
            this.user = window.App.$store.state.models.users.find(user => user.id == this.user_id);
        }

        return this.user;
    }

    setTrustUpIORelationships(data)
    {
        this.trustup_io = data.trustup_io;
    }

    hasRelationship(appKey, modelType, modelId = null)
    {
        let relationship = this.getRelationshipData(appKey, modelType);
        
        if ( ! relationship ) {
            return false;
        }

        if ( ! modelId ) {
            return true;
        }

        return relationship.model_id == modelId;
    }

    getRelationshipModel(models, appKey, modelType)
    {
        if ( ! models || ! this.trustup_io || this.trustup_io.relationships.length == 0 ) {
            return null;
        }

        let relationship = this.getRelationshipData(appKey, modelType);
        if ( ! relationship ) {
            return null;
        }

        return models.find(w => w.uuid == relationship.model_id);
    }

    getRelationshipData(appKey, modelType)
    {
        if ( ! this.trustup_io || ! this.trustup_io.relationships || this.trustup_io.relationships.length == 0 ) {
            return null;
        }

        return this.trustup_io.relationships.find(a => a.app_key == appKey && a.model_type == modelType);
    }

}